/* eslint-disable */
import React from 'react'
import { motion } from 'framer-motion'
import { ReactComponent as WelcomeSigns } from '../../../../assets/img/welcome-signs.svg'

import styles from './styles.module.css'

const Signs = () => (
  <motion.div
    className={styles.signs}
    initial={{
      opacity: 0,
      y: -100,
    }}
    animate={{
      opacity: 1,
      y: 0,
    }}
  >
    <WelcomeSigns />
  </motion.div>
)

export default Signs
